import Dexie, { type EntityTable } from "dexie";
import type {
  DemoPackageRecord,
  DraftRecord,
  SentLetterRecord,
} from "../types";

class FoldDatabase extends Dexie {
  drafts!: EntityTable<DraftRecord, "id">;
  sentLetters!: EntityTable<SentLetterRecord, "letterId">;
  demoPackages!: EntityTable<DemoPackageRecord, "letterId">;

  constructor() {
    super("fold");
    this.version(1).stores({
      drafts: "id, updatedAt",
      sentLetters: "letterId, createdAt",
      demoPackages: "letterId, expiresAt, status",
    });
  }
}

export const database = new FoldDatabase();

let pendingDraftSave: Promise<void> = Promise.resolve();

export function createEmptyDraft(reply?: {
  letterId: string;
  readerToken: string;
}): DraftRecord {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    createdAt: now,
    updatedAt: now,
    senderName: "",
    recipientName: "",
    title: "",
    displayDate: new Intl.DateTimeFormat(undefined, {
      dateStyle: "long",
    }).format(new Date()),
    coverNote: "",
    stationeryId: "warm-ivory",
    expiresInDays: 90,
    replyToLetterId: reply?.letterId ?? null,
    replyReaderToken: reply?.readerToken ?? null,
    pages: [],
  };
}

export function saveDraft(draft: DraftRecord): Promise<void> {
  const snapshot = { ...draft, updatedAt: new Date().toISOString() };
  const operation = pendingDraftSave
    .catch(() => undefined)
    .then(async () => {
      await database.drafts.put(snapshot);
    });
  pendingDraftSave = operation.catch(() => undefined);
  return operation;
}
